import { useRouter } from 'next/router';
import { Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
// Components
import { DollarToCoin, CancelContinueButtons } from '@/components/common/index';
// Utils
import { routes } from '@/routes/routes';
// Assets
import PlaceholderImage from '@/assets/images/PlaceholderImage';

const AddToCartModal = ({
  icon,
  name,
  price,
  coinPrice,
  quantity,
  closeModal,
  isMobile,
}) => {
  const router = useRouter();

  const handleRouting = (path) => () => {
    closeModal();
    router.push(`${path}`);
  };

  return (
    <Box sx={{ width: '100%', minWidth: '250px' }}>
      <IconButton
        onClick={closeModal}
        size="small"
        sx={{
          position: 'absolute',
          right: 6,
          top: 6,
        }}
      >
        <CloseIcon color="grey" fontSize="small" />
      </IconButton>
      <Typography
        variant="h3"
        sx={{
          marginBottom: '24px',
        }}
      >
        Added to Cart
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: isMobile ? 'center' : 'flex-start',
          flexDirection: isMobile ? 'column' : 'row',
          width: '100%',
          gap: '24px',
          marginBottom: '24px',
        }}
      >
        {icon ? (
          <img
            src={icon}
            alt="product"
            style={{
              width: '200px',
              height: 'auto',
            }}
          />
        ) : (
          <PlaceholderImage width={250} height={150} />
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            width: '100%',
          }}
        >
          <Typography variant="h4" data-core-qa="addToCartModalProductName">
            {`${name}`}
          </Typography>
          <DollarToCoin row={false} small dollar={price} coin={coinPrice} />
          <Typography
            variant="body1"
            data-core-qa="addToCartModalQuantity"
            sx={{ marginTop: '4px' }}
          >
            {`Qty: ${quantity}`}
          </Typography>
        </Box>
      </Box>
      <CancelContinueButtons
        fullWidth
        showDivider={isMobile}
        cancelText="Keep Shopping"
        continueText="Begin Checkout"
        onCancel={handleRouting(routes.store.path)}
        onContinue={handleRouting(routes.cart.path)}
      />
    </Box>
  );
};

export default AddToCartModal;
